import { apiClient } from "@lib/axios";
import type { TEndTourPayload, TOnboardingState } from "./onboarding.types";

const path = (path: string) => `/onboarding${path}`;

export const onboardingApi = {
  getState: () => apiClient.get<TOnboardingState>(path("/me")),
  markModalShown: () =>
    apiClient.post<{ recorded: boolean }>(path("/modal-shown")),
  markEditorTourShown: () =>
    apiClient.post<{ recorded: boolean }>(path("/editor-tour-shown")),
  endTour: (payload: TEndTourPayload) =>
    apiClient.post<{ recorded: boolean }, TEndTourPayload>(
      path("/tour"),
      payload,
    ),
  completeTask: (key: string) =>
    apiClient.post<TOnboardingState>(path(`/tasks/${key}`), {
      source: "client",
    }),
  verifyTeamWalkthrough: () =>
    apiClient.post<{ verified: boolean; pending: boolean }>(
      path("/team-walkthrough/verify"),
    ),
  setMadeForYou: (pageId: string, enabled: boolean) =>
    apiClient.post<{ origin: "starter" | null }, { enabled: boolean }>(
      path(`/starter-decks/${pageId}/made-for-you`),
      { enabled },
    ),
};
